import { createSelector } from "reselect";
import { RootState } from "..";

const organizationState = (state: RootState) => state.organization;

/**
 * @description Get organization selected
 */
export const organizationSelector = createSelector(
  organizationState,
  ({ organizations }) => organizations,
);

export const organizationSelectedSelector = createSelector(
  organizationState,
  ({ organizationSelected }) => organizationSelected,
);
